<template>
  <!-- 检测领域 -->
  <div class="detection" ref="detection" style="width: 100%">
    <!-- 页面头部 -->
    <pageHeader ref="pageHeader" pageStatus="2" />
    <!-- 背景图 -->
    <div class="banner" :style="'background-image: url('+ $path + solutionData.pcImageUrl +')'">
      <!-- mask -->
      <div class="banner-mask">
        <!-- 容器 -->
        <div class="banner-ctn">
          <!-- 面包屑 -->
          <div class="breadcrumb">
            <div :class="['solution_nav','font_regular']">
              <span @click="toindex()">首页</span>
              <i class="el-icon-arrow-right"></i>
              <span class="current_title">{{segmentationCharacter(solutionData.name)}}</span>
            </div>
          </div>
          <!-- 当前导航名称 -->
          <div class="curnav-ctn">
            <div class="curnav-text">{{segmentationCharacter(solutionData.name)}}</div>
            <div class="curnav-name"></div>
            <div class="curnav-text">行业解决方案</div>
          </div>
          <!-- 当前导航简介 -->
          <div class="cur-nav-desc">{{solutionData.typeDesc}}</div>
        </div>
      </div>
    </div>
    <!-- 一级导航 -->
    <!-- <div class="nav">
      <div class="nav-ctn">
        <el-tabs v-model="firstNavData.current" @tab-click="changeFirstNav">
          <el-tab-pane v-for="item in firstNavData.list" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
        </el-tabs>
      </div>
    </div> -->
    <!-- https://www.swiper.com.cn/api/methods/109.html 改造 -->
    <!-- 一级导航 -->
    <div class="nav">
      <div class="nav-ctn">
        <div class="prev-btn nav-btn" @click="scollNav('prev')">
          <img src="@/assets/detection/first-nav-pre.png" alt="">
        </div>
        <div class="next-btn nav-btn" @click="scollNav('next')">
          <img src="@/assets/detection/first-nav-next.png" alt="">
        </div>
        <swiper :options="swiperOption" ref="navSwiper">
          <swiper-slide v-for="(item, index) in firstNavData.list" :key="item.id">
            <div class="nav-item" :class="{'active': index === firstNavData.current}" @click="changeFirstNav(index)">
              <div class="svg-icon" v-if="item.logosvg" v-html="item.logosvg"></div>
              <div class="nav-name">{{item.name}}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <!-- 设置背景色 -->
    <div class="bg-color">
      <!-- 二级导航 -->
      <div class="nav-two">
        <div class="nav-two-item" :class="{'active': item.id == twoNavList.current && !$route.query.search}" v-for="(item, idx) in twoNavList.list" :key="idx" @click="changeTwoNav(item)">{{item.name}}</div>
      </div>
      <!-- 搜索框 -->
      <div class="search">
        <div class="search-key">
          <span v-if="$route.query.search">
            以下是关键字“
            <span class="search-key-text">{{searchKeyVal}}</span>
          ”的搜索结果：
          </span>
        </div>
        <div class="search-inpout">
          <el-input
            placeholder="请输入当前分类下的检测服务关键词"
            v-model="searchKey"
            @keyup.enter.native="searchChange"
          >
            <div class="input_search_btn" slot="append" @click="searchChange">搜索</div>
          </el-input>
        </div>
      </div>
      <!-- 二级导航对应内容 -->
      <div class="nav-two-ctn" v-if="productList.length">
        <!-- 商品展示 -->
        <div class="goods-item" @click.prevent="toProductDetail(item)" :class="{'m-r-0': idx % 2 != 0, 'm-b-0': idx > 7}" v-for="(item, idx) in productList" :key="item.id">
          <div class="goods-img">
            <img :src="$path + item.image" alt="">
          </div>
          <div class="goods-ctn">
            <div class="goods-name">
              <div class="goods-name-text">{{item.name}}</div>
              <div class="goods-hot" v-if="item.hots == 1"></div>
            </div>
            <div class="goods-attr">
              <!-- 个工作日 -->
              <span class="sp-1">{{item.testPeriod}}</span>
              <span class="sp-2" v-if="item.urgent == 1">可加急</span>
              <span v-if="item.sample" class="sp-3">样品：{{item.sample}}</span>
            </div>
            <div class="goods-desc">{{item.productOutline}}</div>
            <div class="cancat-btn" @click="show53">咨询工程师></div>
          </div>
        </div>
      </div>
      <!-- 缺省展示 -->
      <div class="empty" v-if="!productList.length">
        <div class="empty-img">
          <img src="@/assets/kong.png" alt="">
        </div>
        <div v-if="$route.query.search">
          <div class="empty-text-one" v-if="page.searchMark == 2">抱歉，当前分类下没有找到您搜索的内容</div>
          <div class="empty-text-one" v-if="page.searchMark == 3">您查找的相关信息正在完善中</div>
          <div class="empty-text-two" v-if="page.searchMark == 2">请在相应分类中进行搜索或立即咨询客服</div>
          <div class="empty-text-two" v-if="page.searchMark == 3">您可立即咨询客服解决您的需求</div>
          <div class="empty-cancat" v-if="page.searchMark == 2 || page.searchMark == 3" @click="show53">咨询客服</div>
        </div>
        <div v-else>
          <div class="empty-text-one">当前分类相关信息正在完善中</div>
          <div class="empty-text-two">您可立即咨询客服解决您的需求</div>
          <div class="empty-cancat" @click="show53">咨询客服</div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="s-pagenation" v-if="page.total > page.size">
        <pagination :pageindex="page.page" :rows="page.size" @handle-changepage="changepage" :total="page.total"></pagination>
      </div>

      <div class="vadio-ctn" v-if="!$route.query.search && curNavArtcle">
        <div class="vadio-sc">
          <div class="vidio-box" @click="showVadioDialog=true">
            <el-image
              style="width: 620px; height: 375px"
              fit="cover"
              :src="$path + videoDetail.art.imageUrl"
            />
            <img class="play-btn" src="@/assets/detection/vadio-play.png" alt="">
          </div>
          <div class="art-box">
            <div class="art-name">{{videoDetail.art.title}}</div>
            <div class="art-desc">{{videoDetail.art.description}}</div>
            <div class="art-view" @click="jumpArtDetail">查看详情 ></div>
          </div>
        </div>
      </div>

      <section class="vadio-dialog" v-if="showVadioDialog">
        <div class="dialog-box">
          <video width="1000" height="562" controls>
            <source :src="$path + videoDetail.vedio.url" type="video/mp4">
          </video>
          <img @click="showVadioDialog = false" class="vadio-close" src="@/assets/detection/vadio-close.png" alt=""/>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { segmentationCharacter } from "@/js/validate.js";

import 'swiper/dist/css/swiper.css';
import 'swiper/dist/js/swiper.js';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
export default {
  components: {
    
    Swiper, SwiperSlide,
    pageHeader: () => import("@/components/header"),
    pagination: () => import("@/components/pagination")
  },
  computed: {
  },
  metaInfo() {
    return {
      title: this.pageInfo.metaTitle,
      meta: [
        {
          name: "keyWords",
          content: this.pageInfo.metaKeywords,
        },
        {
          name: "description",
          content: this.pageInfo.metaDescription,
        },
      ]
    };
  },
  data() {
    return {
      id:'',
      twoLeve:'',
      pageInfo: {
        metaTitle: "",
        metaKeywords: "",
        metaDescription: "",
      },
      firstNavData: {current: 0, list: [] }, // 一级导航菜单
      twoNavList: {current: 0, list: [] }, // 二级导航菜单
      solutionData: {}, // 行业解决方案数据
      segmentationCharacter,
      searchKey: '', // 搜索关键词
      searchKeyVal: '', // 关键词展示
      productList: [], // 产品列表
      page: {
        page: 1,
        size: 10,
        total: 1,
        searchMark: 1 // 搜索状态 1初始值， 2当前分类下没有值， 3全部分类没有值 
      },
      showVadioDialog: false, // 显示视频
      swiperOption: {
        observer:true,
        slidesPerView : 'auto',
        slidesPerGroup : 1,
        spaceBetween: 30,
        freeMode: true,
      },
      curNavArtcle: false, // 底部文章数据是否存在
      videoDetail: {}, // 底部视频相关
    }
  },
  watch:{
    $route(){

      this.id = this.$route.query.id
      if (this.$route.query.twoLeve){
        this.twoLeve = this.$route.query.twoLeve
      }
      this.getSolutionInfo()
      this.searchKey = this.$route.query.search
      this.searchKeyVal = this.$route.query.search
      this.getNavList()
      this.getVideo()
    }
  },
  created() {
    this.id = this.$route.query.id
    if (this.$route.query.twoLeve){
      this.twoLeve = this.$route.query.twoLeve
    }
    this.getSolutionInfo()
  },
  beforeMount() {
    this.searchKey = this.$route.query.search
    this.searchKeyVal = this.$route.query.search
    this.getNavList()
    this.getVideo()
  },
  mounted() {
    const obj = {
      platformType : 1,
      targetPage : window.location.href
    }
    this.$api.iotHome.loggingData(obj)
    .then((res) => {
        if (res.data.success == true) {
        console.log('数据记录成功');
      }
    })
  
 
  },
  methods: {
    getVideo() {
      this.$api.iotHome.videoApi({id: this.firstNavData.list[this.firstNavData.current].id}).then(res => {
        if(res.data.success) {
          if(res.data.data.length) {
            this.videoDetail = {
              vedio: res.data.data[1],
              art: res.data.data[0]
            };
            // 有数据
            this.curNavArtcle = true;
          } else {
            // 无数据
            this.curNavArtcle = false;
          }
        }
      })
    },
    // 获取所有解决方案
    getNavList() {
      if(window.localStorage.getItem("detaList")) {
        this.rangeNavData(JSON.parse(window.localStorage.getItem("detaList")))
          
        this.getProductList();
        return
      }
       this.$api.iotHome
        .typelist({
          id: "",
          siteId: "0",
        })
        .then((res) => {
          if (res.data.success) {
            window.localStorage.setItem("detaList", JSON.stringify(res.data.data));
            this.rangeNavData(res.data.data)
            this.getProductList();
          }
        });
    },
    rangeNavData(list){
      list.some((item, idx) => {
        if(item.id == this.id) {
          this.firstNavData.current = idx
          return true
        }
      })
      this.firstNavData.list = list;
      if(!this.solutionData.id) {
        this.solutionData = list.filter(v => v.id == this.id)[0]
      }
      this.twoNavList.list = this.solutionData.children || []
      this.twoNavList.current = this.twoLeve || this.twoNavList.list[0].id
      
      this.$nextTick(() => {
        // 滚动
        this.$refs.navSwiper.$swiper.slideTo(this.firstNavData.current, 0)
        document.querySelectorAll('.nav-ctn svg').forEach((svg, idx) => {
          if(!svg) return 
          svg.setAttribute('width', '17');
          svg.setAttribute('height', '17');
          svg.querySelectorAll('path').forEach((path) => {
            path.setAttribute('fill', '#777995')
          })
          if(idx == this.firstNavData.current) {
            svg.querySelectorAll('path').forEach((path) => {
              path.setAttribute('fill', '#395FFF')
            })
          }
        })
      })
    
    },
    // 获取解决方案信息
    getSolutionInfo() {
      this.$api.iotHome
        .productClassifyDetail({
          parentId: this.id
        })
        .then((res) => {
          if(res.data.success) {
            this.solutionData = res.data.data
            this.pageInfo.metaTitle = this.solutionData.name ? segmentationCharacter(this.solutionData.name) +'|国检链' : '行业解决方案|国检链'
          }
        });
    },
    
    // 获取二级类别下产品列表
    getProductList(changeScroll = false) {

      if(this.$route.query.search) {
        this.getSearchList()
        return
      }
      const listdata = {
        rows: this.page.size,
        page: this.page.page,
        type: this.twoNavList.current,
        siteId: 0
      }
      this.$api.iotHome.list(listdata).then((res) => {
        if (res.data.success == true) {
          this.productList = res.data.data
          this.page.total = parseInt(res.data.code)
          
          changeScroll && (document.documentElement.scrollTop = 388)
        }
      });
    },
    getSearchList() {
      const _this = this;
      const params = {
        rows: _this.page.size,
        page: _this.page.page,
        name: _this.searchKey,
        id: _this.firstNavData.list[_this.firstNavData.current].id
      }
      _this.$api.iotHome.searchProductList(params).then(res => {
        if(res.data.success) {
          _this.productList = res.data.data.rows
          _this.page.total = parseInt(res.data.total)
          // 初始值
          _this.page.searchMark = 1
          // 当前分类下没有搜到时在全部分类下查找
          if(!res.data.data.length) {
            // 当前分类下没有值
            let searchMark = 2
            const params = {
              rows: _this.page.size,
              page: _this.page.page,
              name: _this.searchKey,
            }
            _this.$api.iotHome.searchProductList(params).then(res => {
              // 所有分类下都没有值
              !(res.data.data?.rows || []).length && (
                searchMark = 3
              )
              _this.page.searchMark = searchMark
            })
          }
        }
      })
    },
    // 改变页面url 
    changeUrl(type) {
      const route = this.$route
      let path = route.path
      let query = {
        id: this.solutionData.id,
        name: this.solutionData.name,
        twoLeve: this.twoNavList.current,
      };
      [1,2].includes(type) ||
        (query.search = this.searchKeyVal)
      
      this.$router.push({path, query}) 

    },
    // 跳转详情
    toProductDetail(data) {
      const { href } = this.$router.resolve({
          path: "/detectionDetail",
          query: {
            id: data.id
          }
      })
      window.open(href, '_blank')
    },
    toindex(data){
      this.$router.push({
        path: "/",
        query: {
          type: data ? data : ''
        }
      });
    },
    // 切换一级导航
    changeFirstNav(idx) {
      // 点击自己无需刷新接口
      if(idx == this.firstNavData.current) {
        return 
      }

      const prevIcon = document.querySelectorAll('.nav-ctn svg')[this.firstNavData.current];
      const curIcon = document.querySelectorAll('.nav-ctn svg')[idx];
      if(prevIcon && curIcon) {
        prevIcon.querySelectorAll('path').forEach((path) => {
          path.setAttribute('fill', '#777995')
        })
        curIcon.querySelectorAll('path').forEach((path) => {
          path.setAttribute('fill', '#395FFF')
        })
      }

      this.firstNavData.current = idx;
      const select = this.firstNavData.list[idx];
      this.twoNavList.list = select.children;
      this.twoNavList.current = select.children[0].id
      this.page.page = 1
      // 以下为获取详情数据
      this.solutionData = select
      this.id = select.id
      // this.getSolutionInfo();
      // 以上为获取详情数据
      // this.getProductList();
      // this.getVideo()
      this.changeUrl(1);
    },
    // 切换二级导航
    changeTwoNav(item) {
      const id = item.id;
    //   if(this.$route.query.search) {
        
    //     let path = this.$route.path
    //     let query = {
    //       id: this.solutionData.id,
    //       name: this.solutionData.name,
    //       twoLeve: id
    //     }
    //     const routeUrl = this.$router.resolve({
    //       path,
    //       query,
    //     });
    //     window.open(routeUrl.href);

    //     return
    //   }
      this.twoNavList.current = id;
      this.page.page = 1
      
      // this.getProductList()
      this.changeUrl(2)
    },
    // 滑动
    scollNav(type) {
      if(type === 'prev') {
        this.$refs.navSwiper.$swiper.slideTo(0, 200)
      } else if(type === 'next') {
        this.$refs.navSwiper.$swiper.slideTo(this.firstNavData.list.length, 200)
      }
    },
    show53() {
      const specs="height=600,width=1000,alwaysRaised,directories=no,toolbar=no,titlebar=no,menubar=no,scrollbars=no,left=300,top = 200, resizable=no,location=no, status=no"
      window.open("https://tb.53kf.com/code/client/5cd60bbe34341ac131de2c0cddeef983/4","_blank",specs)
    },
    // 跳转文章
    jumpArtDetail() {
      const routeUrl = this.$router.resolve({
        path: '/enterpriseDetail',
        query: {id: this.videoDetail.art.articleId},
      });
      window.open(routeUrl.href);
    },
    // 切换分页
    changepage(val) {
      console.log(val)
      this.page.page = val
      this.getProductList(true)
      // this.changeUrl()
    },
    // 搜索
    searchChange() {
      if(!this.searchKey) {
        this.$message({
          message: '请输入要搜索的关键字~',
          type: 'warning',
        });
        return
      };
      // 页面来源搜索
      // if(this.$route.query.search) {
      this.searchKeyVal = this.searchKey
      // this.getProductList()
      
      this.changeUrl();
      return
      // }

      // 页面来源二级页面
      let path = route.path
      let query = {
        id: this.solutionData.id,
        name: this.solutionData.name,
        search: this.searchKey
      }
      const routeUrl = this.$router.resolve({
        path,
        query,
      });
      window.open(routeUrl.href);

    }
    
  }
};
</script>
<style lang="scss" scoped>
  .banner {
    width: 100%;
    height: 240px;
    background-origin: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
  .banner-mask {
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: .35);
  }
  .banner-ctn {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding-top: 26px;
  }
  .solution_nav {
    height: 14px;
    font-size: 14px;
    color: #CCCDDC;
    line-height: 1;
    font-family: PingFangSC-Regular;
    span {
      cursor: pointer;
    }
    .current_title {
      color: #fff;
      cursor: default;
    }
  }
  .curnav-ctn {
    margin-top: 47px;
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 36px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .curnav-name {
    width: 4px;
    height: 38px;
    background: #fff;
    margin: 0 15px;
  }
  .cur-nav-desc {
    margin-top: 17px;
    width: 864px;
    height: 40px;
    line-height: 20px;
    font-size: 12px;
    color: #fff;
    
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .nav {
    width: 100%;
    height: 70px;
    background: #fff;
  }
  .nav-ctn {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  .nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 40px;
    padding: 5px;
    z-index: 10;
    cursor: pointer;
    img {
      width: 100%;
      object-fit: contain;
    }
    &.prev-btn {
      left: -45px;

    }
    &.next-btn {
      right: -45px;
    }
  }
  .bg-color {
    width: 100%;
    background: #F3F4F9;
    // min-height: 500px;
  }
  .nav-two {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    padding: 40px 0 6px;
  }
  .nav-two-item {
    float: left;
    padding: 0 18px;
    border-radius: 6px;
    margin-right: 20px;
    line-height: 30px;
    color: #282B45;
    cursor: pointer;
    margin-bottom: 20px;
    &:hover {
      background: #fff;
    }
    &.active {
      background: #FF9A22;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
  }
  .search {
    width: 1200px;
    margin: 0 auto;
    // height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .p-t-26 {
    padding-top: 26px;
  }
  .search-key {
    font-size: 14px;
    line-height: 30px;
    color: #777995;
  }
  .search-key-text {
    color: #224CFF;
  }  
  .input_search_btn {
    width: 70px;
    line-height: 28px;
    background: #224CFF;
    border: 1px solid #224CFF;
    border-radius: 0px 6px 6px 0px;
    text-align: center;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    &:hover {
      opacity: 0.7;
    }
    &:active {
      opacity: 0.8;
    }
  }
  .nav-two-ctn {
    width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    // overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 40px;
  }
  .goods-item {
    width: 594px;
    height: 204px;
    background: #FFFFFF;
    border-radius: 12px;
    // float: left;
    padding: 24px;
    padding-right: 11px;
    display: flex;
    justify-content: flex-start;
    margin-right: 12px;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 8px 20px 0px rgba(94, 97, 108, 0.1);
    }
  }
  .m-r-0 {
    margin-right: 0;
  }
  .m-b-0 {
    margin-bottom: 0;
  }
  .goods-img {
    width: 260px;
    height: 156px;
    border-radius: 4px;
    margin-right: 25px;
    // border: 1px solid red;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goods-ctn {
    padding-top: 11px;
    flex: 1;
    .goods-name {
      width: 263px;
      // display: flex;
      // justify-content: flex-start;
      margin-bottom: 10px;
      // overflow: hidden;
      &:after {
        content: '';
        clear: both;
        height: 0;
        line-height: 0;
        display: block;
        visibility: hidden;
      }
    }
    .goods-name-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      color: #282B45;
      line-height: 20px;
      // flex: 1;
      float: left;
      max-width: 224px;
    }
    .goods-hot {
      margin-left: 3px;
      flex: 1;
      width: 32px;
      height: 22px;
      background: url('../../assets/detection/pc-hot.png') no-repeat center;
      background-size: contain;
      position: relative;
      top: -8px;
      float: left;
    }
    .goods-attr {
      width: 274px;
      font-size: 12px;
      line-height: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #777995;
      height: 20px;
      margin-bottom: 14px;
      white-space: nowrap;
      span {
        padding: 0 8px;
        border: 1px solid #777995;
        border-radius: 4px;
        margin-right: 6px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        &.sp-1 {
          max-width: 100px;
        }
        &.sp-2 {
          width: 54px;
        }
        &.sp-3 {
          max-width: 110px;
          margin: 0;
          
        }
      }
    }
    .goods-desc {
      width: 246px;
      height: 32px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #A2A3B4;
      line-height: 16px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .cancat-btn {
      margin-top: 15px;
      width: 106px;
      line-height: 28px;
      background: #FFFFFF;
      border: 1px solid #7892FF;
      text-align: center;
      color: #395FFF;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        color: #fff;
        background: #395FFF;
        border-color: #395FFF;
      }
      &:active {
        opacity: 0.7;
      }
    }
  }

  .empty {
    width: 1200px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 1px;
    min-height: 429px;
    .empty-img {
      width: 222px;
      height: 176px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .empty-text-one {
      margin-top: 41px;
      width: 100%;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      color: #282B45;
      line-height: 19px;
      text-align: center;
    }
    .empty-text-two {
      margin-top: 10px;
      text-align: center;
      width: 100%;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #A2A3B4;
      line-height: 16px;
    }
    .empty-cancat {
      width: 140px;
      line-height: 44px;
      background: #224CFF;
      border: 1px solid #224CFF;
      border-radius: 6px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      margin: 0 auto;
      margin-top: 30px;
      margin-bottom: 60px;
      cursor: pointer;
    }

  }


  .vadio-ctn {
    width: 100%;
    background: #fff;
    height: 456px;
    padding: 40px;
    // margin-top: 40px;
  }
  .vadio-sc {
    width: 1280px;
    height: 376px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
  }
  .vidio-box {
    width: 620px;
    height: 375px;
    position: relative;
    cursor: pointer;
  }
  .play-btn {
    width: 84px;
    height: 84px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .art-box {
    width: 760px;
    height: 376px;
    background: #F3F3F3;
    padding: 73px 88px 62px 96px;
    .art-name {
      width: 575px;
      height: 29px;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #787A8D;
      line-height: 29px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .art-desc {
      width: 577px;
      height: 120px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #A2A3B4;
      line-height: 24px;
      margin-top: 27px;
      margin-bottom: 38px;
    }
    .art-view {
      width: 120px;
      // height: 34px;
      background: #395FFF;
      border: 1px solid #7892FF;
      text-align: center;
      line-height: 32px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
    }

  }

  .vadio-dialog {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba($color: #000000, $alpha: .5);
    z-index: 9999;
    .dialog-box {
      width: 1000px;
      height: 562px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    video {
      object-fit: cover
    }
    .vadio-close {
      position: absolute;
      right: -70px;
      top: 0;
      // width: 50px;
      // height: 50px;
      object-fit: cover;
      cursor: pointer;
    }
  }

  .nav-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    // background: skyblue;
    // padding: 0 20px;
    cursor: pointer;
    .svg-icon {
      width: 17px;
      padding-top: 2px;
      margin-right: 7px;
    }
    &.active {
      position: relative;
      color: #395FFF;
      &:after {
        content: '';
        width: 100%;
        height: 3px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background: #395FFF;
      }
    }
  }

  
</style>

<style lang="scss">
  .nav-ctn {
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__item {
      height: 70px;
      line-height: 70px;
      font-size: 16px;
    }
    .el-tabs__nav-wrap::after {
      background-color: #fff;
    }
    .el-tabs__item:hover {
      color: #395FFF;
    }
    .el-tabs__item.is-active {
      color: #395FFF;

    }
    .el-tabs__active-bar {
      background-color: #395FFF;

    }
  }

  .search {
    .el-input-group__append, .el-input-group__prepend {
      border: none;
      background-color: #395FFF;
      padding: 0;
    }
    .el-input__inner {
      width: 252px !important;
      height: 30px!important;
      line-height: 30px!important;
      font-size: 12px;
      background: transparent;
    }
  }
  .nav-ctn {
    .el-tabs__nav-prev, .el-tabs__nav-next {
      background: #EEF0F4;
      line-height: 30px;
      top: 50%;
      transform: translateY(-50%);
      padding: 0 2px;
    }
    [class*=" el-icon-"], [class^=el-icon-] {
      font-weight: 900;
    }
  }
  .s-pagenation {
    .pagination_container{
      .el-pagination {
        width: 100%;
        overflow-x:auto;
        text-align: center;
        padding: 0 0 40px 0 ;
      }
      .el-pager{
        li{
          color: #9698a0!important;
          border-radius: 2px;
          border: 1px solid #A2A3B4;
        }
        li.active{
          background: #395FFF!important;
          color: #fff!important;
        }
        li.active:hover{
          color: #fff!important;
        }
        li:hover{
          color: #9698a0!important;
        }
      }
    }
    .pcpaginationContainer{
      .el-pagination {
        padding: 0 0 40px 0;
      }
      .btn-prev{
        min-width: 40px!important;
        min-height: 40px!important;
        border: 1px solid #A2A3B4;
      }
      .btn-next{
        min-width: 40px!important;
        min-height: 40px!important;
        border: 1px solid #A2A3B4;
      }
      .el-pager{
        .more::before{
          line-height: 40px;
        }
        li{
          min-width: 40px!important;
          min-height: 40px!important;
          line-height: 40px;
        }
      }
    }
  }

  .el-message {
    top: 20%!important;
  }
  .container-style {
    min-height: 100px!important;
  }
  .nav-ctn {
    .swiper-slide {
      width: auto !important;
    }
  }
  .svg-icon { 
    .cls-1, .cls-2 {
      stroke: #777995;
      fill: #777995
    }
    .cls-3 {
      fill: #777995;
    }

  }
  .active .svg-icon {
    .cls-1, .cls-2 {
      stroke: #395FFF;
      fill: #395FFF
    }
    .cls-3 {
      fill: #395FFF;
    }
  }
</style>